export const DateTimeFormat = {
  DATE_TIME: 'MMM DD, YYYY hh:mm A',
  SHORT: 'MMM DD, YYYY',
  DATE: 'MM/DD/YYYY',
  TIME: 'hh:mm',
  AM_PM: 'A',
  ISO_DATE_TIME: 'YYYY-MM-DD[T]HH:mm:ss',
  WEEK_TIME: 'MMM DD',
  DATE_PICKER: 'dddd, MMMM DD',
  CREATED_DATE: 'ddd, MMM DD'
}

export const DEFAULT_PAGE_SIZE = 25

export const TOKEN_KEY = 'token'

export const BOOTSTRAP_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
  LIGHT: 'light',
  DARK: 'dark',
  LIGHT_BLUE: 'light-blue',
  OUTLINE: 'outline',

  OUTLINE_PRIMARY: 'outline-primary',
  OUTLINE_SECONDARY: 'outline-secondary',
  OUTLINE_SUCCESS: 'outline-success',
  OUTLINE_WARNING: 'outline-warning',
  OUTLINE_DANGER: 'outline-danger',
  OUTLINE_INFO: 'outline-info',
  OUTLINE_LIGHT: 'outline-light',
  OUTLINE_DARK: 'outline-dark',
  OUTLINE_LIGHT_BLUE: 'outline-light-blue',

  LINK: 'link'
}

export const FILE_UPLOAD_ACCEPTED = ['.pdf', '.png', '.gif', '.jpg']
